import React, { Component } from 'react';
import {Redirect} from "react-router-dom";
import axios from 'axios';
import CajaImagen from "./CajaImagen";
import "./../styles/pagImagenesStyle.css";
import "./../styles/formTextItem.css";
import ImageService from "../services/Image.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class PagImagenes extends Component {
    state = {
        images: [],
        isLoggedIn: false,
        firstTime: true,
        loading: true
    };

    async componentDidMount(){
        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({isLoggedIn: response.data.isLoggedIn, firstTime: false}); 

        if(response.data.isLoggedIn){
            const response = await ImageService.get();
            if(response.status !== 200){
                alert(`Error: ${response.data.message}`);
            } else {
                this.setState({ loading: false, images: response.data.images });
            }
        }
    }

    deleteImageHandler = async (index) => {
        const data = {
            UUID: this.state.images[index].UUID,
            path: this.state.images[index].path
        }
        const response = await ImageService.delete(data);
        
        if(response.data.message === 'DELETE_IMAGE_SUCCESSFUL'){
            let newImages = this.state.images;
            newImages.splice(index, 1);
            this.setState({ items: newImages });
        } else {
            alert(`Error: ${response.data.message}`);
        }
    }
    addImageHandler = async (e) => {
        if(e.target.files[0].size >= 30000000){
            alert("La imagen es muy grande. Debe pesar menos de 30Mb");
        } else {
            var data = new FormData();
            data.append("image", e.target.files[0]);
            const response = await ImageService.post(data);

            if(response.data.message === 'POST_IMAGE_SUCCESSFUL'){
                let newImages = this.state.images;
                newImages.unshift(response.data.image);

                this.setState({ images: newImages });
            } else {
                alert(`Error: ${response.data.message}`);
            }
        }
        
    }

    render() {
        var dataReturn;
        if(this.state.images.length>0){
            dataReturn=<div className="grillaImagenes">
                {
                    this.state.images.map((image, index) => {
                        return <React.Fragment key={image.originalName}>
                            <CajaImagen
                                key = {index}
                                UUID = {image.UUID}
                                originalName = {image.originalName}
                                path = {SERVER_URL + image.path}
                                onDelete = {this.deleteImageHandler}
                                imgNum = {index}
                            />
                        </React.Fragment>
                    })
                }
            </div>
        }else{
            dataReturn=<p className="notFound">No hay ninguna imagen o foto para ver, comience agregando una.</p>
        }
        var dataLoader=<div className="LoadingContainer">
            <div className="loader"></div>    
        </div>

        return (this.state.isLoggedIn || this.state.firstTime)
        ?(
            <div className="card formTextItem">
                <h1>Mi galeria de imagenes</h1>
                <p className="description">Crea tu propio almacén de recuerdos y momentos que fueron divertidos, alegres,
                que te hacen sentir bien o que te produzcan tranquilidad, usando fotos o imágenes. Pueden ser momentos con
                personas que querés, imágenes de cosas que te gustan (como por ejemplo paisajes, animales, arte, etc...), o cualquier otra cosa
                que te genere sensación de bienestar.</p>
                <form action="/uploadImage" method="POST" id="imageForm" encType="multipart/form-data">
                    <input type="file" id="image" name="image" onChange={this.addImageHandler} />
                    <label htmlFor="image" className="btn" id="btnAgregar"><i className="material-icons-round">add</i>Agregar nueva imagen</label>
                </form>    

                {this.state.loading ? dataLoader : dataReturn}
            </div>
        )
        : <Redirect to="/" />
    }
}
